import { createGlobalStyle } from "styled-components";
// import "./fonts.css";
import Gmarket from "../fonts/GmarketSansOTF/GmarketSansMedium.otf";
import GmarketBold from "../fonts/GmarketSansOTF/GmarketSansBold.otf";
import GmarketLight from "../fonts/GmarketSansOTF/GmarketSansLight.otf";
import deadJim from "../fonts/DEADJIM.otf";

import { viewSizes } from "./variables";

const GlobalStyle = createGlobalStyle`

@font-face {
  font-family: "GmarketSans";
  src: url(${Gmarket})
    format("opentype");
}
@font-face {
  font-family: "GmarketSans";
  font-weight: bold;
  src: url(${GmarketBold})
    format("opentype");
}
@font-face {
  font-family: "GmarketSans";
  font-weight: lighter;
  src: url(${GmarketLight})
    format("opentype");
}
/*  */
@font-face {
    font-family: 'SpoqaHanSansNeo-Light';
    src: url('https://cdn.jsdelivr.net/gh/projectnoonnu/noonfonts_2108@1.1/SpoqaHanSansNeo-Light.woff') format('woff');
    font-weight: normal;
    font-style: normal;
}

@font-face {
  font-family: "SpoqaHanSansNeo-Regular";
  src: url("https://cdn.jsdelivr.net/gh/projectnoonnu/noonfonts_2108@1.1/SpoqaHanSansNeo-Regular.woff")
    format("woff");
  font-weight: normal;
  font-style: normal;
}

@font-face {
    font-family: 'SpoqaHanSansNeo-Medium';
    src: url('https://cdn.jsdelivr.net/gh/projectnoonnu/noonfonts_2108@1.1/SpoqaHanSansNeo-Medium.woff') format('woff');
    font-weight: normal;
    font-style: normal;
}


@font-face {
    font-family: 'SpoqaHanSansNeo-Bold';
    src: url('https://cdn.jsdelivr.net/gh/projectnoonnu/noonfonts_2108@1.1/SpoqaHanSansNeo-Bold.woff') format('woff');
    font-weight: normal;
    font-style: normal;
}

/*  */
@font-face {
  font-family: "deadJim";
  /* font-weight: lighter; */
  src: url(${deadJim})
    format("opentype");
}


*{
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-family: 'GmarketSans', serif;
    font-style: normal;
    font-weight: normal;
    line-height: 1.43;
    list-style: none;
    
  }


  
  html{
    font-size: 10px;
 
    @media only screen and (max-width: ${viewSizes.tablet}) {
      font-size: 8px;
    }
  }


`;

export default GlobalStyle;
